import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { useProCountryFeatures } from '../hooks/useProCountryFeatures';

type GateFeature = 'billingUi' | 'boarding' | 'efacturation';

type Props = {
  feature: GateFeature;
  children: React.ReactNode;
  /** Destination si feature indisponible */
  fallbackTo?: string;
};

/**
 * Bloque l'accès à une route si la feature pays est désactivée (ex. BE).
 * FR inchangé (features True).
 */
export const RequireCountryFeature: React.FC<Props> = ({
  feature,
  children,
  fallbackTo = '/app',
}) => {
  const { t } = useTranslation('common');
  const features = useProCountryFeatures();
  const allowed =
    feature === 'billingUi'
      ? features.billingUi
      : feature === 'boarding'
        ? features.boarding
        : features.efacturation;

  useEffect(() => {
    if (!allowed) {
      toast.info(t('countryFeatures.unavailable'));
    }
  }, [allowed, t]);

  if (!allowed) {
    return <Navigate to={fallbackTo} replace />;
  }

  return <>{children}</>;
};

export default RequireCountryFeature;
